import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { Button, Field, Input } from '@/shared/ui'
import { ApiError } from '@/shared/api/client'
import { useLogin } from '../model'
import styles from './AuthForm.module.css'

export function LoginForm() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const login = useLogin()

  const error = login.error instanceof ApiError ? login.error : undefined

  function submit(event: FormEvent) {
    event.preventDefault()
    login.mutate({ email: email.trim(), password })
  }

  return (
    <form className={styles.form} onSubmit={submit} noValidate>
      {/* Сообщение сверху, а не под кнопкой: сервер на вход отвечает
          одинаково и на незнакомую почту, и на неверный пароль, поэтому
          привязать ошибку к конкретному полю нельзя. */}
      {error && !error.field && <div className={styles.error}>{error.message}</div>}

      <Field label="Рабочая почта" error={error?.field === 'email' ? error.message : undefined}>
        {(props) => (
          <Input
            {...props}
            type="email"
            // autoComplete нужен не для красоты: без него менеджер
            // паролей не предложит сохранённый вход, и человек
            // набирает почту руками каждый раз.
            autoComplete="username"
            inputMode="email"
            placeholder="ivan@company.ru"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            invalid={Boolean(error)}
            autoFocus
            required
          />
        )}
      </Field>

      <Field label="Пароль" error={error?.field === 'password' ? error.message : undefined}>
        {(props) => (
          <Input
            {...props}
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            invalid={Boolean(error)}
            required
          />
        )}
      </Field>

      <div className={styles.footer}>
        <Button type="submit" fullWidth loading={login.isPending}>
          Войти
        </Button>
        <p className={styles.switcher}>
          Ещё нет компании?{' '}
          <Link className={styles.link} to="/register">
            Зарегистрировать
          </Link>
        </p>
      </div>
    </form>
  )
}
